module.exports = __webpack_public_path__ + "img/app.d317a6db.jpg";